/*
 * Liora · Birthstone drawer (template product.birthstone only).
 * Proxies the Liora Product Options swatch radios into a side drawer with gem cards,
 * a N/N counter and an add-to-cart lock. The app's radios stay the source of truth:
 * choosing a card checks the original radio and dispatches `change`, so the app keeps
 * validating and mirroring properties into the cart form exactly as before.
 * Markup placeholder + critical CSS are rendered by the `custom` block of the template.
 */
(function () {
  'use strict';
  if (window.__lioraBirthstone) return;
  window.__lioraBirthstone = true;

  var I18N = {
    es: { stones: 'Elige tus piedras', eyes: 'Elige los colores de ojos', free: '(Gratis)', confirm: 'Confirmar', missing: 'Elige una opción en cada hueco', close: 'Cerrar', pear: 'pera', emerald: 'rectangular', marquise: 'marquesa', round: 'redonda', oval: 'oval' },
    en: { stones: 'Choose your stones', eyes: 'Choose the eye colours', free: '(Free)', confirm: 'Confirm', missing: 'Pick one for each slot', close: 'Close', pear: 'pear', emerald: 'emerald', marquise: 'marquise', round: 'round', oval: 'oval' },
    fr: { stones: 'Choisissez vos pierres', eyes: 'Choisissez les couleurs des yeux', free: '(Offert)', confirm: 'Confirmer', missing: 'Choisissez une option pour chaque emplacement', close: 'Fermer', pear: 'poire', emerald: 'émeraude', marquise: 'marquise', round: 'ronde', oval: 'ovale' },
    it: { stones: 'Scegli le tue pietre', eyes: 'Scegli i colori degli occhi', free: '(Gratis)', confirm: 'Conferma', missing: "Scegli un'opzione per ogni posizione", close: 'Chiudi', pear: 'goccia', emerald: 'smeraldo', marquise: 'marquise', round: 'tonda', oval: 'ovale' },
    de: { stones: 'Wähle deine Steine', eyes: 'Wähle die Augenfarben', free: '(Kostenlos)', confirm: 'Bestätigen', missing: 'Wähle eine Option für jede Position', close: 'Schließen', pear: 'Tropfen', emerald: 'Smaragd', marquise: 'Marquise', round: 'rund', oval: 'oval' },
    pt: { stones: 'Escolhe as tuas pedras', eyes: 'Escolhe as cores dos olhos', free: '(Grátis)', confirm: 'Confirmar', missing: 'Escolhe uma opção para cada posição', close: 'Fechar', pear: 'pera', emerald: 'esmeralda', marquise: 'marquesa', round: 'redonda', oval: 'oval' },
    nl: { stones: 'Kies je stenen', eyes: 'Kies de oogkleuren', free: '(Gratis)', confirm: 'Bevestigen', missing: 'Kies een optie voor elke plek', close: 'Sluiten', pear: 'peer', emerald: 'smaragd', marquise: 'marquise', round: 'rond', oval: 'ovaal' },
    da: { stones: 'Vælg dine sten', eyes: 'Vælg øjenfarverne', free: '(Gratis)', confirm: 'Bekræft', missing: 'Vælg en mulighed for hver plads', close: 'Luk', pear: 'dråbe', emerald: 'smaragd', marquise: 'marquise', round: 'rund', oval: 'oval' },
    cs: { stones: 'Vyberte své kameny', eyes: 'Vyberte barvy očí', free: '(Zdarma)', confirm: 'Potvrdit', missing: 'Vyberte možnost pro každou pozici', close: 'Zavřít', pear: 'kapka', emerald: 'smaragd', marquise: 'markýza', round: 'kulatý', oval: 'oválný' },
    el: { stones: 'Επίλεξε τις πέτρες σου', eyes: 'Επίλεξε τα χρώματα των ματιών', free: '(Δωρεάν)', confirm: 'Επιβεβαίωση', missing: 'Επίλεξε μία επιλογή για κάθε θέση', close: 'Κλείσιμο', pear: 'αχλάδι', emerald: 'σμαράγδι', marquise: 'μαρκίζα', round: 'στρογγυλή', oval: 'οβάλ' },
    fi: { stones: 'Valitse kivesi', eyes: 'Valitse silmien värit', free: '(Ilmainen)', confirm: 'Vahvista', missing: 'Valitse vaihtoehto jokaiseen kohtaan', close: 'Sulje', pear: 'pisara', emerald: 'smaragdi', marquise: 'markiisi', round: 'pyöreä', oval: 'soikea' },
    hu: { stones: 'Válaszd ki a köveidet', eyes: 'Válaszd ki a szemszíneket', free: '(Ingyenes)', confirm: 'Megerősítés', missing: 'Válassz minden helyre egy lehetőséget', close: 'Bezárás', pear: 'csepp', emerald: 'smaragd', marquise: 'marquise', round: 'kerek', oval: 'ovális' },
    nb: { stones: 'Velg steinene dine', eyes: 'Velg øyenfargene', free: '(Gratis)', confirm: 'Bekreft', missing: 'Velg et alternativ for hver plass', close: 'Lukk', pear: 'dråpe', emerald: 'smaragd', marquise: 'marquise', round: 'rund', oval: 'oval' },
    pl: { stones: 'Wybierz swoje kamienie', eyes: 'Wybierz kolory oczu', free: '(Gratis)', confirm: 'Potwierdź', missing: 'Wybierz opcję dla każdego miejsca', close: 'Zamknij', pear: 'gruszka', emerald: 'szmaragd', marquise: 'markiza', round: 'okrągły', oval: 'owalny' },
    ro: { stones: 'Alege-ți pietrele', eyes: 'Alege culorile ochilor', free: '(Gratuit)', confirm: 'Confirmă', missing: 'Alege o opțiune pentru fiecare poziție', close: 'Închide', pear: 'pară', emerald: 'smarald', marquise: 'marchiză', round: 'rotundă', oval: 'ovală' },
    sv: { stones: 'Välj dina stenar', eyes: 'Välj ögonfärgerna', free: '(Gratis)', confirm: 'Bekräfta', missing: 'Välj ett alternativ för varje plats', close: 'Stäng', pear: 'droppe', emerald: 'smaragd', marquise: 'marquise', round: 'rund', oval: 'oval' }
  };

  var SHAPES = {
    round: { outer: '<circle cx="50" cy="50" r="42"/>', table: 'M50 26 L67 33 L74 50 L67 67 L50 74 L33 67 L26 50 L33 33 Z', pts: [[50, 8], [80, 20], [92, 50], [80, 80], [50, 92], [20, 80], [8, 50], [20, 20]] },
    pear: { outer: '<path d="M50 5 C66 26 84 46 84 64 A34 32 0 0 1 16 64 C16 46 34 26 50 5 Z"/>', table: 'M50 34 L64 50 L64 68 L50 78 L36 68 L36 50 Z', pts: [[50, 5], [78, 44], [84, 66], [70, 90], [50, 96], [30, 90], [16, 66], [22, 44]] },
    marquise: { outer: '<path d="M50 3 C80 28 80 72 50 97 C20 72 20 28 50 3 Z"/>', table: 'M50 26 L62 42 L62 58 L50 74 L38 58 L38 42 Z', pts: [[50, 3], [68, 22], [73, 50], [68, 78], [50, 97], [32, 78], [27, 50], [32, 22]] },
    oval: { outer: '<ellipse cx="50" cy="50" rx="34" ry="45"/>', table: 'M50 24 L64 34 L68 50 L64 66 L50 76 L36 66 L32 50 L36 34 Z', pts: [[50, 5], [74, 18], [84, 50], [74, 82], [50, 95], [26, 82], [16, 50], [26, 18]] },
    emerald: { outer: '<path d="M26 6 L74 6 L90 22 L90 78 L74 94 L26 94 L10 78 L10 22 Z"/>', table: 'M36 26 L64 26 L70 32 L70 68 L64 74 L36 74 L30 68 L30 32 Z', pts: [[26, 6], [74, 6], [90, 22], [90, 78], [74, 94], [26, 94], [10, 78], [10, 22]] }
  };

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var scrollBehavior = reducedMotion ? 'auto' : 'smooth';

  function luminance(color) {
    var m = String(color).match(/\d+(\.\d+)?/g);
    if (!m || m.length < 3) return 0.5;
    var c = m.slice(0, 3).map(function (v) {
      v = +v / 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
  }

  var uid = 0;
  function gemSvg(cut, color) {
    var s = SHAPES[cut] || SHAPES.round;
    var id = 'lbs-clip-' + (++uid);
    var light = luminance(color) > 0.6;
    var tablePts = s.table.replace(/[MLZ]/g, ' ').trim().split(/\s+/);
    var tv = [];
    for (var i = 0; i < tablePts.length; i += 2) tv.push([+tablePts[i], +tablePts[i + 1]]);
    var lines = s.pts.map(function (p, i) {
      var t = tv[Math.round(i * tv.length / s.pts.length) % tv.length];
      return '<line x1="' + p[0] + '" y1="' + p[1] + '" x2="' + t[0] + '" y2="' + t[1] + '"/>';
    }).join('');
    var lineColor = light ? '#7a8590' : '#fff';
    return '<svg viewBox="0 0 100 100" aria-hidden="true" focusable="false">' +
      '<defs><clipPath id="' + id + '">' + s.outer + '</clipPath></defs>' +
      '<g clip-path="url(#' + id + ')">' +
      '<rect width="100" height="100" fill="' + color + '"/>' +
      '<path d="M0 0 H100 L0 100 Z" fill="#fff" opacity=".22"/>' +
      '<path d="M100 100 H0 L100 0 Z" fill="#000" opacity="' + (light ? '.1' : '.16') + '"/>' +
      '<path d="' + s.table + '" fill="#fff" opacity=".28"/>' +
      '<g stroke="' + lineColor + '" stroke-opacity="' + (light ? '.55' : '.45') + '" stroke-width="1.2">' + lines + '</g>' +
      '<ellipse cx="36" cy="30" rx="10" ry="6" fill="#fff" opacity=".55" transform="rotate(-30 36 30)"/>' +
      '</g>' +
      '<g fill="none" stroke="' + (light ? '#5f6b75' : '#000') + '" stroke-opacity="' + (light ? '.6' : '.18') + '" stroke-width="' + (light ? '2.2' : '1.5') + '">' + s.outer + '</g>' +
      '</svg>';
  }

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function start(config) {
    var loc = (config.dataset.locale || 'es').toLowerCase();
    var t = I18N[loc] || I18N[loc.split('-')[0]] || I18N.en;
    var cuts = (config.dataset.cuts || '').split(',').filter(Boolean);
    var title = config.dataset.kind === 'eyes' ? t.eyes : t.stones;
    var form = document.querySelector('form[action*="/cart/add"]');

    function swatchFields() {
      return Array.prototype.filter.call(document.querySelectorAll('.liora-options .liora-field--swatch'), function (f) {
        return f.dataset.hidden !== 'true' && f.querySelector('input[type="radio"]');
      });
    }

    var fields = swatchFields();
    if (!fields.length) return false;

    document.documentElement.classList.add('lbs-active');

    // ---- Trigger (fills the placeholder rendered by the template block)
    var trigger = el('button', 'lbs-trigger');
    trigger.type = 'button';
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.innerHTML = '<span class="lbs-trigger__plus" aria-hidden="true"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.25"><path d="M8 2v12M2 8h12"/></svg></span>' +
      '<span class="lbs-trigger__text">' + escapeHtml(title) + ' <span class="lbs-faded">' + escapeHtml(t.free) + '</span></span>' +
      '<span class="lbs-count lbs-faded"></span>';
    var hint = el('span', 'lbs-visually-hidden');
    hint.id = 'lbs-atc-hint';
    hint.textContent = title;
    config.innerHTML = '';
    config.appendChild(trigger);
    config.appendChild(hint);

    // ---- Drawer
    var dialog = el('dialog', 'lbs-drawer');
    dialog.setAttribute('aria-label', title);
    var img = config.dataset.image ? '<div class="lbs-drawer__image"><img src="' + escapeHtml(config.dataset.image) + '" alt="" loading="lazy" width="600" height="600"></div>' : '';
    dialog.innerHTML =
      '<div class="lbs-drawer__inner">' +
        '<div class="lbs-drawer__head"><h2 class="lbs-drawer__title">' + escapeHtml(title) + ' <span class="lbs-count lbs-faded"></span></h2>' +
        '<button type="button" class="lbs-drawer__close" aria-label="' + escapeHtml(t.close) + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" aria-hidden="true" focusable="false"><path d="M5 5l14 14M19 5L5 19"/></svg></button></div>' +
        '<div class="lbs-drawer__body">' + img + '<div class="lbs-groups"></div></div>' +
        '<div class="lbs-drawer__foot"><p class="lbs-missing" role="alert" hidden>' + escapeHtml(t.missing) + '</p>' +
        '<button type="button" class="lbs-confirm"><span>' + escapeHtml(t.confirm) + '</span><span class="lbs-count" aria-hidden="true"></span></button>' +
        '<span class="lbs-visually-hidden lbs-live" aria-live="polite"></span></div>' +
      '</div>';
    document.body.appendChild(dialog);
    var groupsWrap = dialog.querySelector('.lbs-groups');
    var missingMsg = dialog.querySelector('.lbs-missing');
    var live = dialog.querySelector('.lbs-live');

    function handleize(v) {
      return String(v).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    }
    var assetBase = config.dataset.assetBase || '';
    function swatchUrl(cut, value) {
      if (!assetBase) return null;
      var family = config.dataset.kind === 'eyes' ? 'eye' : 'stone';
      return assetBase + 'lbs-' + family + '-' + cut + '-' + handleize(value) + '.png';
    }

    // Combination photo (Indigo Lune style): <handle>[-plata]_<value1>_<value2>[_<value3>].jpg in Shopify Files.
    // Shown in the drawer and over the main product photo, and sent as the hidden `_Foto` property.
    // If the file does not exist nothing changes.
    var filesBase = config.dataset.filesBase || '';
    var variantColor = {};
    try { JSON.parse((document.querySelector('[data-lbs-variants]') || {}).textContent || '[]').forEach(function (v) { variantColor[v.id] = v.c; }); } catch (_) {}
    var photoState = { key: null, url: null };
    var photoCache = {};
    function photoInput() {
      if (!form) return null;
      var inp = form.querySelector('input[name="properties[_Foto]"]');
      if (!inp) {
        inp = document.createElement('input');
        inp.type = 'hidden'; inp.name = 'properties[_Foto]'; inp.disabled = true;
        form.appendChild(inp);
      }
      return inp;
    }
    function mainPhoto() {
      return document.querySelector('.product__main-photos .product-main-slide img, .product__main-photos img');
    }
    function applyPhoto(url) {
      var drawerImg = dialog.querySelector('.lbs-drawer__image img');
      if (drawerImg) {
        if (!drawerImg.dataset.lbsOriginal) drawerImg.dataset.lbsOriginal = drawerImg.src;
        drawerImg.src = url || drawerImg.dataset.lbsOriginal;
      }
      var main = mainPhoto();
      if (main && main.parentNode) {
        var overlay = main.parentNode.querySelector('.lbs-combo-photo');
        if (url) {
          if (!overlay) {
            overlay = document.createElement('img');
            // `lazyloaded` + forced opacity: the theme hides gallery images until its lazy loader marks them.
            overlay.className = 'lbs-combo-photo lazyloaded'; overlay.alt = '';
            overlay.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;z-index:2;background:#fff;';
            overlay.style.setProperty('opacity', '1', 'important');
            if (getComputedStyle(main.parentNode).position === 'static') main.parentNode.style.position = 'relative';
            main.parentNode.appendChild(overlay);
          }
          overlay.src = url;
        } else if (overlay) {
          overlay.remove();
        }
      }
      var inp = photoInput();
      if (inp) { inp.value = url || ''; inp.disabled = !url; }
    }
    // Colour = position of the checked option1 radio (0 Oro, 1 Plata), locale-agnostic. The hidden
    // variant <select> is empty when every variant is sold out, so it is only a fallback.
    function currentColorIndex() {
      var radios = document.querySelectorAll('input[type="radio"][data-index="option1"]');
      for (var i = 0; i < radios.length; i++) if (radios[i].checked) return i;
      var m = location.search.match(/[?&]variant=(\d+)/);
      if (m && variantColor[m[1]] != null) return variantColor[m[1]];
      var idInput = form && form.querySelector('[name="id"]');
      if (idInput && variantColor[idInput.value] != null) return variantColor[idInput.value];
      return 0;
    }
    function syncPhoto(s) {
      if (!filesBase || !config.dataset.handle) return;
      var key = null;
      if (s.chosenAll) {
        var color = currentColorIndex();
        var values = fields.map(function (f) { var c = f.querySelector('input[type="radio"]:checked'); return c ? handleize(c.value) : 'null'; });
        key = config.dataset.handle + (color === 1 ? '-plata' : '') + '_' + values.join('_') + '.jpg';
      }
      if (key === photoState.key) return;
      photoState.key = key;
      if (!key) { applyPhoto(null); return; }
      var url = 'https:' + filesBase.replace(/^https?:/, '') + key;
      if (photoCache[url] === true) { applyPhoto(url); return; }
      if (photoCache[url] === false) { applyPhoto(null); return; }
      var probe = new Image();
      probe.onload = function () { photoCache[url] = true; if (photoState.key === key) applyPhoto(url); };
      probe.onerror = function () { photoCache[url] = false; if (photoState.key === key) applyPhoto(null); };
      probe.src = url;
    }

    function fieldLabel(f) {
      var l = f.querySelector('.liora-label');
      return l ? l.textContent.replace(/\*/g, '').trim() : '';
    }
    function radiosOf(f) { return f.querySelectorAll('input[type="radio"]'); }
    function optionLabel(radio) {
      var sw = radio.closest('.liora-swatch');
      var lbl = sw && sw.querySelector('.liora-swatch__label');
      return lbl ? lbl.textContent.trim() : radio.value;
    }

    function choose(f, radio) {
      if (radio.disabled) return;
      radio.checked = true;
      radio.dispatchEvent(new Event('input', { bubbles: true }));
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      var s = update();
      live.textContent = fieldLabel(f) + ': ' + optionLabel(radio) + ' · ' + s.done + '/' + s.total;
    }

    function render() {
      fields = swatchFields();
      groupsWrap.innerHTML = '';
      fields.forEach(function (f, i) {
        var cut = cuts[i] || cuts[cuts.length - 1] || 'round';
        var g = el('section', 'lbs-group');
        g.appendChild(el('h3', 'lbs-group__title', escapeHtml(fieldLabel(f)) + '*'));
        var grid = el('div', 'lbs-grid');
        grid.setAttribute('role', 'radiogroup');
        grid.setAttribute('aria-label', fieldLabel(f));
        Array.prototype.forEach.call(radiosOf(f), function (radio) {
          var sw = radio.closest('.liora-swatch');
          var circle = sw && sw.querySelector('.liora-swatch__circle');
          var color = circle && circle.style.backgroundColor ? circle.style.backgroundColor : '#ddd';
          var card = el('button', 'lbs-card');
          card.type = 'button';
          card.setAttribute('role', 'radio');
          card.setAttribute('aria-checked', radio.checked ? 'true' : 'false');
          card.disabled = radio.disabled;
          var name = optionLabel(radio);
          var longest = name.split(/\s+/).reduce(function (m, w) { return Math.max(m, w.length); }, 0);
          if (longest > 10) grid.classList.add('lbs-grid--wide');
          card.innerHTML = '<span class="lbs-card__swatch" aria-hidden="true"></span><span class="lbs-card__label">' + escapeHtml(name) + '</span>';
          var swatchWrap = card.firstChild;
          var photo = swatchUrl(cut, radio.value);
          if (photo) {
            var simg = new Image();
            simg.alt = ''; simg.loading = 'lazy'; simg.decoding = 'async'; simg.width = 96; simg.height = 96;
            simg.onerror = function () { swatchWrap.innerHTML = gemSvg(cut, color); };
            simg.src = photo;
            swatchWrap.appendChild(simg);
          } else {
            swatchWrap.innerHTML = gemSvg(cut, color);
          }
          card.addEventListener('click', function (e) {
            choose(f, radio);
            // Pointer users jump to the next pending slot; keyboard users keep their focus in place.
            if (e.detail > 0) {
              var next = groupsWrap.querySelector('.lbs-group:not(.is-done)');
              if (next && next !== g) next.scrollIntoView({ behavior: scrollBehavior, block: 'start' });
              else if (!next) dialog.querySelector('.lbs-drawer__foot').scrollIntoView({ behavior: scrollBehavior, block: 'end' });
            }
          });
          grid.appendChild(card);
        });
        // Radio-group keyboard pattern: one tab stop, arrows move + select.
        grid.addEventListener('keydown', function (e) {
          var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1, Home: 'first', End: 'last' };
          if (!(e.key in keys)) return;
          var cards = Array.prototype.filter.call(grid.querySelectorAll('.lbs-card'), function (c) { return !c.disabled; });
          if (!cards.length) return;
          var idx = cards.indexOf(document.activeElement);
          var k = keys[e.key];
          var nextIdx = k === 'first' ? 0 : k === 'last' ? cards.length - 1 : (idx + k + cards.length) % cards.length;
          e.preventDefault();
          cards[nextIdx].focus();
          cards[nextIdx].click();
        });
        g.appendChild(grid);
        groupsWrap.appendChild(g);
      });
      update();
    }

    // A choice only counts for add-to-cart once the app has copied it into the cart form
    // (its mirrors). Until then the property would not travel with the POST.
    function inForm(radio) {
      if (!form) return true;
      var data;
      try { data = new FormData(form); } catch (_) { return false; }
      return data.getAll(radio.name).indexOf(radio.value) !== -1;
    }

    var resyncTimer = null;
    function state() {
      var done = 0;
      var synced = 0;
      var values = [];
      fields.forEach(function (f) {
        var checked = f.querySelector('input[type="radio"]:checked');
        if (checked && !checked.disabled) {
          done++;
          if (inForm(checked)) synced++;
          values.push(fieldLabel(f) + ': ' + optionLabel(checked));
        }
      });
      var chosenAll = done === fields.length;
      var complete = chosenAll && synced === fields.length;
      if (chosenAll && !complete && !resyncTimer) {
        resyncTimer = setTimeout(function () { resyncTimer = null; update(); }, 400);
      }
      return { done: done, total: fields.length, chosenAll: chosenAll, complete: complete, values: values };
    }

    function atcButtons() {
      return form ? form.querySelectorAll('[data-add-to-cart], button[name="add"]') : [];
    }

    function update() {
      var s = state();
      var txt = s.done + '/' + s.total;
      document.querySelectorAll('.lbs-count').forEach(function (c) { c.textContent = txt; });
      hint.textContent = title + ' (' + txt + ')';
      trigger.classList.toggle('is-complete', s.complete);
      document.documentElement.classList.toggle('lbs-complete', s.complete);
      groupsWrap.querySelectorAll('.lbs-group').forEach(function (g, i) {
        var f = fields[i];
        var radios = f ? radiosOf(f) : [];
        var checked = f && f.querySelector('input[type="radio"]:checked');
        g.classList.toggle('is-done', !!checked);
        if (checked) g.classList.remove('is-missing');
        var cards = g.querySelectorAll('.lbs-card');
        var tabbable = null;
        cards.forEach(function (card, j) {
          var on = !!(radios[j] && radios[j].checked);
          card.setAttribute('aria-checked', on ? 'true' : 'false');
          if (on) tabbable = card;
        });
        if (!tabbable) tabbable = Array.prototype.find.call(cards, function (c) { return !c.disabled; });
        cards.forEach(function (card) { card.tabIndex = card === tabbable ? 0 : -1; });
      });
      if (s.chosenAll) missingMsg.hidden = true;
      syncPhoto(s);
      atcButtons().forEach(function (b) {
        b.classList.toggle('lbs-locked', !s.complete);
        if (!s.complete) {
          b.setAttribute('aria-describedby', 'lbs-atc-hint');
          if (!b.disabled) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
        } else {
          b.removeAttribute('aria-describedby');
          b.removeAttribute('aria-disabled');
        }
        if (!b.querySelector('.lbs-atc-label')) {
          var lab = el('span', 'lbs-atc-label');
          lab.setAttribute('aria-hidden', 'true');
          lab.textContent = title;
          b.appendChild(lab);
        }
      });
      return s;
    }

    function flagMissing() {
      missingMsg.hidden = false;
      var first = null;
      groupsWrap.querySelectorAll('.lbs-group').forEach(function (g) {
        var miss = !g.classList.contains('is-done');
        g.classList.toggle('is-missing', miss);
        if (miss && !first) first = g;
      });
      if (first) {
        first.scrollIntoView({ behavior: scrollBehavior, block: 'start' });
        var focusCard = first.querySelector('.lbs-card[tabindex="0"]');
        if (focusCard) focusCard.focus({ preventScroll: true });
      }
    }

    var lastFocus = null;
    var openedAt = 0;
    function open(showMissing) {
      if (!dialog.open) {
        lastFocus = document.activeElement;
        openedAt = Date.now();
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        document.documentElement.classList.add('lbs-open');
      }
      update();
      if (showMissing) {
        flagMissing();
      } else {
        missingMsg.hidden = true;
        groupsWrap.querySelectorAll('.lbs-group.is-missing').forEach(function (g) { g.classList.remove('is-missing'); });
      }
    }
    function close() {
      if (typeof dialog.close === 'function' && dialog.open) dialog.close();
      else dialog.removeAttribute('open');
      document.documentElement.classList.remove('lbs-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    trigger.addEventListener('click', function () { open(false); });
    dialog.querySelector('.lbs-drawer__close').addEventListener('click', close);
    dialog.addEventListener('close', function () { document.documentElement.classList.remove('lbs-open'); });
    // Backdrop click closes, except for the tail of the click/double-click that opened it.
    dialog.addEventListener('click', function (e) { if (e.target === dialog && Date.now() - openedAt > 450) close(); });
    dialog.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var focusables = Array.prototype.filter.call(dialog.querySelectorAll('button:not([disabled])'), function (b) {
        return b.tabIndex !== -1 && b.offsetParent !== null;
      });
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    dialog.querySelector('.lbs-confirm').addEventListener('click', function () {
      if (update().chosenAll) close();
      else flagMissing();
    });

    // Block add-to-cart (click, keyboard submit, programmatic submit) while incomplete
    // or while the app has not yet copied the choices into the form.
    function guard(e) {
      var s = update();
      if (s.complete) return;
      var btn = e.type === 'click' ? e.target.closest && e.target.closest('[data-add-to-cart], button[name="add"], button[type="submit"]') : null;
      if (e.type === 'click' && (!btn || !form || !form.contains(btn))) return;
      if (btn && btn.disabled) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!s.chosenAll) open(true);
    }
    document.addEventListener('click', guard, true);
    if (form) form.addEventListener('submit', guard, true);

    // Keep in sync with the app (its own validation, conditionals, variant changes, bfcache).
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.liora-options')) update();
    });
    document.addEventListener('variant:change', update);
    // The browser restores checked radios after back/forward without firing `change`.
    window.addEventListener('pageshow', function () { setTimeout(update, 0); });
    window.addEventListener('load', function () { setTimeout(update, 0); });
    // The app creates its mirror inputs when it boots (possibly after us).
    if (form && window.MutationObserver) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        setTimeout(function () { pending = false; update(); }, 50);
      }).observe(form, { childList: true, subtree: true });
    }
    document.addEventListener('liora:ready', function () { setTimeout(update, 0); });

    document.documentElement.classList.remove('lbs-failed');
    render();
    window.__lbsReady = true;
    return true;
  }

  // Give the page back to the app (its own swatches and validation) if the drawer cannot run.
  function release() {
    document.documentElement.classList.add('lbs-failed');
    window.__lbsReleased = true;
  }

  function boot() {
    var config = document.querySelector('[data-liora-birthstone]');
    if (!config || config.dataset.lbsReady) return;
    var tries = 0;
    (function attempt() {
      var ok = false;
      try { ok = start(config); } catch (err) { release(); return; }
      if (ok) { config.dataset.lbsReady = '1'; return; }
      if (++tries < 50) setTimeout(attempt, 200);
      else release();
    })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
